import React from 'react';

/**
 * Celey Branded Loading Component
 * Features a subtle balloon bounce animation with optional loading text
 */
const CeleyLoader = ({ 
  text = null, 
  size = 'default', // 'small', 'default', 'large'
  className = '' 
}) => {
  const sizeClasses = {
    small: 'w-8 h-8',
    default: 'w-12 h-12',
    large: 'w-16 h-16'
  };

  const textSizeClasses = {
    small: 'text-xs',
    default: 'text-sm',
    large: 'text-base'
  };

  return (
    <div className={`flex flex-col items-center justify-center gap-3 ${className}`}>
      {/* Balloon Icon with Float Animation */}
      <div className="relative">
        {/* Balloon SVG */}
        <svg 
          viewBox="0 0 64 64" 
          className={`${sizeClasses[size]} animate-balloon-float`}
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          {/* Balloon body */}
          <ellipse 
            cx="32" 
            cy="26" 
            rx="18" 
            ry="22" 
            className="fill-emerald-500"
          />
          {/* Balloon highlight */}
          <ellipse 
            cx="26" 
            cy="20" 
            rx="6" 
            ry="8" 
            className="fill-emerald-300 opacity-50"
          />
          {/* Balloon knot */}
          <path 
            d="M32 48 L29 52 L35 52 Z" 
            className="fill-emerald-600"
          />
          {/* Balloon string */}
          <path 
            d="M32 52 Q30 56 32 60 Q34 64 32 68" 
            stroke="#9CA3AF" 
            strokeWidth="1.5" 
            fill="none"
            strokeLinecap="round"
            className="animate-string-sway"
          />
        </svg>

        {/* Subtle sparkle effects */}
        <div className="absolute -top-1 -right-1 w-2 h-2 bg-amber-400 rounded-full animate-sparkle opacity-75" />
        <div className="absolute top-2 -left-2 w-1.5 h-1.5 bg-emerald-300 rounded-full animate-sparkle-delayed opacity-60" />
      </div>

      {/* Loading text */}
      {text && (
        <p className={`text-gray-500 font-medium ${textSizeClasses[size]} animate-pulse`}>
          {text}
        </p>
      )}
    </div>
  );
};

/**
 * Full page loader overlay
 */
export const CeleyPageLoader = ({ text = 'Loading...' }) => {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <CeleyLoader text={text} size="large" />
    </div>
  );
};

/**
 * Inline loader for cards/sections
 */
export const CeleyInlineLoader = ({ text = null }) => {
  return (
    <div className="py-8">
      <CeleyLoader text={text} size="default" />
    </div>
  );
};

export default CeleyLoader;
